const getFontSize = (state = 0.7, action) => {
  switch (action.type) {
    case 'SET_FONT_SIZE':
      return action.payload;
    default:
      return state;
  }
};

export default getFontSize;
